import { useState } from 'react';
import { sendApiRequest } from '../../api/request';
import EditingPanel from './EditingPanel';

export default function AboutParagraphs() {
  const [action, setAction] = useState('create');
  const [id, setId] = useState('');
  const [language, setLanguage] = useState('');
  const [text, setText] = useState('');
  const [orderIndex, setOrderIndex] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = async () => {
    setMessage('');
    if (!id || !language) {
      setMessage('Please provide both ID and language.');
      return;
    }

    try {
      if (action === 'create') {
        if (!text) {
          setMessage('Please provide text for the paragraph.');
          return;
        }

        const paragraphData = {
          paragraphId: { id: Number(id), language },
          text,
          orderIndex: orderIndex ? Number(orderIndex) : 0,
        };

        const saved = await sendApiRequest('POST', '/admin/about', paragraphData);
        setMessage(`Paragraph saved: ID ${saved?.paragraphId?.id} (${saved?.paragraphId?.language})`);

        setId('');
        setLanguage('');
        setText('');
        setOrderIndex('');
      } else if (action === 'delete') {
        await sendApiRequest(
          'DELETE',
          `/admin/about/paragraph?id=${id}&language=${language}`
        );
        setMessage(`Paragraph with ID ${id} (${language}) deleted.`);

        setId('');
        setLanguage('');
        setText('');
        setOrderIndex('');
      }
    } catch (error) {
      setMessage(`${error?.message ?? 'Request failed'}`);
    }
  };

  return (
    <EditingPanel
      title={action === 'create' ? 'Create / Update Paragraph' : 'Delete Paragraph'}
      action={action}
      onActionChange={setAction}
      actions={[
        { value: 'create', label: 'Create / Update' },
        { value: 'delete', label: 'Delete' },
      ]}
      topRow={
        <>
          <div className="editing-panel__field">
            <label>Paragraph ID</label>
            <input
              type="number"
              value={id}
              onChange={(e) => setId(e.target.value)}
              placeholder="Enter paragraph ID"
            />
          </div>
          <div className="editing-panel__field">
            <label>Language</label>
            <input
              type="text"
              value={language}
              onChange={(e) => setLanguage(e.target.value)}
              placeholder="e.g. en or no"
            />
          </div>
        </>
      }
      grid={
        action === 'create' && (
          <>
            <div className="editing-panel__field editing-panel__field--span-2">
              <label>Text</label>
              <textarea
                value={text}
                onChange={(e) => setText(e.target.value)}
                placeholder="Enter paragraph text"
              />
            </div>

            <div className="editing-panel__field">
              <label>Order Index</label>
              <input
                type="number"
                value={orderIndex}
                onChange={(e) => setOrderIndex(e.target.value)}
                placeholder="Display order (optional)"
              />
            </div>
          </>
        )
      }
      onSubmit={handleSubmit}
      isDanger={action === 'delete'}
      submitLabel={action === 'delete' ? 'Delete Paragraph' : 'Save Paragraph'}
      message={message}
    />
  );
}
